import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, ShoppingBag, ShoppingCart, Truck, User } from "lucide-react";
import { useShop } from "../context/ShopContext";
import { useAuth } from "../context/AuthContext";

const HIDDEN_ON = ["/admin", "/checkout", "/product/"];

const linkClass = ({ isActive }) =>
  `flex flex-col items-center justify-center gap-0.5 flex-1 h-full min-w-[44px] transition-colors ${
    isActive ? "text-[#D96A1B]" : "text-white/60"
  }`;

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const { cartCount, openCartDrawer } = useShop();
  const { user } = useAuth();

  if (HIDDEN_ON.some((p) => pathname.startsWith(p))) return null;

  const accountPath = user ? (user.role === "admin" ? "/admin" : "/account") : "/signin";

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="md:hidden fixed bottom-0 inset-x-0 h-16 z-40 bg-[#0A0A0A]/95 backdrop-blur-xl border-t border-white/10 px-2 flex items-center justify-around"
    >
      <NavLink to="/" end data-testid="mobile-nav-home" className={linkClass}>
        <Home size={20} />
        <span className="text-[10px] font-display tracking-wide uppercase">Home</span>
      </NavLink>
      <NavLink to="/shop" data-testid="mobile-nav-shop" className={linkClass}>
        <ShoppingBag size={20} />
        <span className="text-[10px] font-display tracking-wide uppercase">Shop</span>
      </NavLink>
      <button
        data-testid="mobile-nav-cart"
        onClick={openCartDrawer}
        className="flex flex-col items-center justify-center gap-0.5 flex-1 h-full min-w-[44px] text-white/60 hover:text-[#D96A1B]"
      >
        <span className="relative">
          <ShoppingCart size={20} />
          {cartCount > 0 && (
            <span data-testid="mobile-nav-cart-badge" className="absolute -top-1.5 -right-2 text-[9px] bg-[#D96A1B] text-white font-display px-1 py-0.5 leading-none">
              {cartCount}
            </span>
          )}
        </span>
        <span className="text-[10px] font-display tracking-wide uppercase">Cart</span>
      </button>
      <NavLink to="/track-order" data-testid="mobile-nav-track" className={linkClass}>
        <Truck size={20} />
        <span className="text-[10px] font-display tracking-wide uppercase">Track</span>
      </NavLink>
      <NavLink to={accountPath} data-testid="mobile-nav-account" className={linkClass}>
        <User size={20} />
        <span className="text-[10px] font-display tracking-wide uppercase">Account</span>
      </NavLink>
    </nav>
  );
}
